var React = require('react');

function Square (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"100%","height":"100%"}));
}

Square.defaultProps = {"className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Square;

Square.default = Square;
